import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Sequence1quqbxersk0bb as Sequence } from './Sequence.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../hacks.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { EmptyIterator_instance23xvvm1c2fncv as EmptyIterator_instance } from '../collections/CollectionsKt.mjs';
import { asSequence2jzw5xbq99nu9 as asSequence } from '../collections/_Arrays.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from '../collections/AbstractIterator.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../collections/HashSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function generateSequence(seedFunction, nextFunction) {
  return new (GeneratorSequence())(seedFunction, nextFunction);
}
var TransformingSequence$iterator$1Class;
function TransformingSequence$iterator$1() {
  if (TransformingSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.sm_1 = this$0;
        this.rm_1 = this$0.tm_1.m1();
      }
      o1() {
        return this.sm_1.um_1(this.rm_1.o1());
      }
      n1() {
        return this.rm_1.n1();
      }
    }
    initMetadataForClass($);
    TransformingSequence$iterator$1Class = $;
  }
  return TransformingSequence$iterator$1Class;
}
var TransformingSequenceClass;
function TransformingSequence() {
  if (TransformingSequenceClass === VOID) {
    class $ {
      constructor(sequence, transformer) {
        this.tm_1 = sequence;
        this.um_1 = transformer;
      }
      m1() {
        return new (TransformingSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TransformingSequence', VOID, VOID, [Sequence()]);
    TransformingSequenceClass = $;
  }
  return TransformingSequenceClass;
}
function calcNext($this) {
  while ($this.vm_1.n1()) {
    var item = $this.vm_1.o1();
    if ($this.ym_1.bn_1(item) === $this.ym_1.an_1) {
      $this.xm_1 = item;
      $this.wm_1 = 1;
      return Unit_instance;
    }
  }
  $this.wm_1 = 0;
}
var FilteringSequence$iterator$1Class;
function FilteringSequence$iterator$1() {
  if (FilteringSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.ym_1 = this$0;
        this.vm_1 = this$0.zm_1.m1();
        this.wm_1 = -1;
        this.xm_1 = null;
      }
      o1() {
        if (this.wm_1 === -1) {
          calcNext(this);
        }
        if (this.wm_1 === 0)
          throw NoSuchElementException().y1();
        var result = this.xm_1;
        this.xm_1 = null;
        this.wm_1 = -1;
        return (result == null ? true : !(result == null)) ? result : THROW_CCE();
      }
      n1() {
        if (this.wm_1 === -1) {
          calcNext(this);
        }
        return this.wm_1 === 1;
      }
    }
    initMetadataForClass($);
    FilteringSequence$iterator$1Class = $;
  }
  return FilteringSequence$iterator$1Class;
}
var FilteringSequenceClass;
function FilteringSequence() {
  if (FilteringSequenceClass === VOID) {
    class $ {
      constructor(sequence, sendWhen, predicate) {
        sendWhen = sendWhen === VOID ? true : sendWhen;
        this.zm_1 = sequence;
        this.an_1 = sendWhen;
        this.bn_1 = predicate;
      }
      m1() {
        return new (FilteringSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'FilteringSequence', VOID, VOID, [Sequence()]);
    FilteringSequenceClass = $;
  }
  return FilteringSequenceClass;
}
function ensureItemIterator($this) {
  var itemIterator = $this.dn_1;
  if (!(itemIterator == null) && itemIterator.n1()) {
    $this.en_1 = 1;
    return true;
  }
  while ($this.cn_1.n1()) {
    var element = $this.cn_1.o1();
    var nextItemIterator = $this.fn_1.in_1($this.fn_1.hn_1(element));
    if (nextItemIterator.n1()) {
      $this.dn_1 = nextItemIterator;
      $this.en_1 = 1;
      return true;
    }
  }
  $this.en_1 = 2;
  $this.dn_1 = null;
  return false;
}
var FlatteningSequence$iterator$1Class;
function FlatteningSequence$iterator$1() {
  if (FlatteningSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.fn_1 = this$0;
        this.cn_1 = this$0.gn_1.m1();
        this.dn_1 = null;
        this.en_1 = 0;
      }
      o1() {
        if (this.en_1 === 2)
          throw NoSuchElementException().y1();
        if (this.en_1 === 0 && !ensureItemIterator(this)) {
          throw NoSuchElementException().y1();
        }
        this.en_1 = 0;
        return ensureNotNull(this.dn_1).o1();
      }
      n1() {
        if (this.en_1 === 1)
          return true;
        if (this.en_1 === 2)
          return false;
        return ensureItemIterator(this);
      }
    }
    initMetadataForClass($);
    FlatteningSequence$iterator$1Class = $;
  }
  return FlatteningSequence$iterator$1Class;
}
var FlatteningSequenceClass;
function FlatteningSequence() {
  if (FlatteningSequenceClass === VOID) {
    class $ {
      constructor(sequence, transformer, iterator) {
        this.gn_1 = sequence;
        this.hn_1 = transformer;
        this.in_1 = iterator;
      }
      m1() {
        return new (FlatteningSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'FlatteningSequence', VOID, VOID, [Sequence()]);
    FlatteningSequenceClass = $;
  }
  return FlatteningSequenceClass;
}
function emptySequence() {
  return EmptySequence_instance;
}
var DropTakeSequenceClass;
function DropTakeSequence() {
  if (DropTakeSequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTakeSequence', VOID, VOID, [Sequence()]);
    DropTakeSequenceClass = $;
  }
  return DropTakeSequenceClass;
}
var TakeSequence$iterator$1Class;
function TakeSequence$iterator$1() {
  if (TakeSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.jn_1 = this$0.mn_1;
        this.kn_1 = this$0.ln_1.m1();
      }
      o1() {
        if (this.jn_1 === 0)
          throw NoSuchElementException().y1();
        this.jn_1 = this.jn_1 - 1 | 0;
        return this.kn_1.o1();
      }
      n1() {
        return this.jn_1 > 0 && this.kn_1.n1();
      }
    }
    initMetadataForClass($);
    TakeSequence$iterator$1Class = $;
  }
  return TakeSequence$iterator$1Class;
}
var TakeSequenceClass;
function TakeSequence() {
  if (TakeSequenceClass === VOID) {
    class $ {
      constructor(sequence, count) {
        this.ln_1 = sequence;
        this.mn_1 = count;
        // Inline function 'kotlin.require' call
        if (!(this.mn_1 >= 0)) {
          var message = 'count must be non-negative, but was ' + this.mn_1 + '.';
          throw IllegalArgumentException().a1(toString(message));
        }
      }
      n2(n) {
        return n >= this.mn_1 ? this : new (TakeSequence())(this.ln_1, n);
      }
      m1() {
        return new (TakeSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TakeSequence', VOID, VOID, [Sequence(), DropTakeSequence()]);
    TakeSequenceClass = $;
  }
  return TakeSequenceClass;
}
function calcNext_0($this) {
  $this.nn_1 = $this.on_1 === -2 ? $this.pn_1.qn_1() : $this.pn_1.rn_1(ensureNotNull($this.nn_1));
  $this.on_1 = $this.nn_1 == null ? 0 : 1;
}
var GeneratorSequence$iterator$1Class;
function GeneratorSequence$iterator$1() {
  if (GeneratorSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.pn_1 = this$0;
        this.nn_1 = null;
        this.on_1 = -2;
      }
      o1() {
        if (this.on_1 < 0) {
          calcNext_0(this);
        }
        if (this.on_1 === 0)
          throw NoSuchElementException().y1();
        var tmp = this.nn_1;
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.on_1 = -1;
        return result;
      }
      n1() {
        if (this.on_1 < 0) {
          calcNext_0(this);
        }
        return this.on_1 === 1;
      }
    }
    initMetadataForClass($);
    GeneratorSequence$iterator$1Class = $;
  }
  return GeneratorSequence$iterator$1Class;
}
var GeneratorSequenceClass;
function GeneratorSequence() {
  if (GeneratorSequenceClass === VOID) {
    class $ {
      constructor(getInitialValue, getNextValue) {
        this.qn_1 = getInitialValue;
        this.rn_1 = getNextValue;
      }
      m1() {
        return new (GeneratorSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'GeneratorSequence', VOID, VOID, [Sequence()]);
    GeneratorSequenceClass = $;
  }
  return GeneratorSequenceClass;
}
var EmptySequenceClass;
function EmptySequence() {
  if (EmptySequenceClass === VOID) {
    class $ {
      m1() {
        return EmptyIterator_instance;
      }
      n2(n) {
        return EmptySequence_instance;
      }
    }
    initMetadataForObject($, 'EmptySequence', VOID, VOID, [Sequence(), DropTakeSequence()]);
    EmptySequenceClass = $;
  }
  return EmptySequenceClass;
}
var EmptySequence_instance;
function EmptySequence_getInstance() {
  return EmptySequence_instance;
}
function generateSequence_0(seed, nextFunction) {
  var tmp;
  if (seed == null) {
    tmp = EmptySequence_instance;
  } else {
    tmp = new (GeneratorSequence())(() => seed, nextFunction);
  }
  return tmp;
}
function sequenceOf(element) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (sequenceOf$$inlined$Sequence$1())(element);
}
function sequenceOf_0(elements) {
  return asSequence(elements);
}
var DistinctSequenceClass;
function DistinctSequence() {
  if (DistinctSequenceClass === VOID) {
    class $ {
      constructor(source, keySelector) {
        this.sn_1 = source;
        this.tn_1 = keySelector;
      }
      m1() {
        return new (DistinctIterator())(this.sn_1.m1(), this.tn_1);
      }
    }
    initMetadataForClass($, 'DistinctSequence', VOID, VOID, [Sequence()]);
    DistinctSequenceClass = $;
  }
  return DistinctSequenceClass;
}
var DistinctIteratorClass;
function DistinctIterator() {
  if (DistinctIteratorClass === VOID) {
    class $ extends AbstractIterator() {
      constructor(source, keySelector) {
        super();
        this.wn_1 = source;
        this.xn_1 = keySelector;
        this.yn_1 = HashSet().ha();
      }
      yj() {
        while (this.wn_1.n1()) {
          var next = this.wn_1.o1();
          var key = this.xn_1(next);
          if (this.yn_1.v(key)) {
            this.zj(next);
            return Unit_instance;
          }
        }
        this.ak();
      }
    }
    initMetadataForClass($, 'DistinctIterator');
    DistinctIteratorClass = $;
  }
  return DistinctIteratorClass;
}
var sequenceOf$1Class;
function sequenceOf$1() {
  if (sequenceOf$1Class === VOID) {
    class $ {
      constructor($element) {
        this.ao_1 = $element;
        this.zn_1 = true;
      }
      o1() {
        if (!this.zn_1)
          throw NoSuchElementException().y1();
        this.zn_1 = false;
        return this.ao_1;
      }
      n1() {
        return this.zn_1;
      }
    }
    initMetadataForClass($);
    sequenceOf$1Class = $;
  }
  return sequenceOf$1Class;
}
var sequenceOf$$inlined$Sequence$1Class;
function sequenceOf$$inlined$Sequence$1() {
  if (sequenceOf$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($element) {
        this.bo_1 = $element;
      }
      m1() {
        return new (sequenceOf$1())(this.bo_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Sequence()]);
    sequenceOf$$inlined$Sequence$1Class = $;
  }
  return sequenceOf$$inlined$Sequence$1Class;
}
//region block: init
EmptySequence_instance = new (EmptySequence())();
//endregion
//region block: exports
export {
  DistinctSequence as DistinctSequence1lbisrkxedews,
  DropTakeSequence as DropTakeSequence18qfczyunxcax,
  FilteringSequence as FilteringSequence3rfik2d45zn1y,
  FlatteningSequence as FlatteningSequence1gb46kmahgjp0,
  TakeSequence as TakeSequencecj2mz1r3ww35,
  TransformingSequence as TransformingSequence3gzv034v2j93f,
  emptySequence as emptySequence25zpp7hgtqwdd,
  generateSequence_0 as generateSequence118suk3hffuuw,
  generateSequence as generateSequence2pi96ci7lpz88,
  sequenceOf_0 as sequenceOf1mtha40gp6gat,
  sequenceOf as sequenceOfdrc6uefhtiet,
};
//endregion

//# sourceMappingURL=Sequences.mjs.map
